import gsap from "gsap";

export default {
  init() {
    const trigger = document.querySelector(".book-full__cover-zoom");
    if (!trigger) {
      return;
    }
    const overlay = document.querySelector(".book-full__lightbox-overlay");
    const lightbox = document.querySelector(".book-full__lightbox");
    const image = lightbox.querySelector("img");
    const closeTriggers = document.querySelectorAll(
      ".book-full__lightbox-close, .book-full__lightbox-overlay"
    );

    trigger.addEventListener("click", () => {
      gsap.to(overlay, {
        duration: 0.2,
        opacity: 1,
        ease: "power2.inOut",
      });

      gsap.fromTo(
        lightbox,
        { opacity: 0, scale: 0.95 },
        {
          duration: 0.2,
          opacity: 1,
          scale: 1,
          ease: "power2.inOut",
        }
      );

      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      overlay.style.pointerEvents = "auto";
      image.style.pointerEvents = "auto";
    });

    for (const trigger of closeTriggers) {
      trigger.addEventListener("click", () => {
        isOpen = false;

        gsap.to(overlay, {
          duration: 0.2,
          opacity: 0,
          ease: "power2.inOut",
        });

        gsap.to(lightbox, {
          duration: 0.2,
          opacity: 0,
          ease: "power2.inOut",
          onComplete: () => {
            document.body.style.overflow = "";
            document.body.style.paddingRight = "";
            overlay.style.pointerEvents = "none";
            image.style.pointerEvents = "none";
          },
        });
      });
    }
  },
};
